import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  scrollBehavior: () => ({ y: 0 }),

  routes: [
    {
      path: "/",
      redirect: "/paint_task_manage",
    },
    {
      path: "/",
      component: (resolve) => require(["@/components/common/Home"], resolve),
      meta: {
        title: "自述文件",
      },
      children: [
        { path: '/capacity_dashboard', component: () => import('@/components/page/CapacityDashboard'), meta: { title: '美术产能中枢', noOuterScroll: true } },
        { path: '/config_project_team', component: () => import('@/components/page/ConfigurationProjectTeam'), meta: { title: '项目组配置' } },
        { path: '/config_subject', component: () => import('@/components/page/ConfigurationSubject'), meta: { title: '题材配置' } },
        { path: '/config_art_team', component: () => import('@/components/page/ConfigurationArtTeam'), meta: { title: '团队配置' } },
        {
          path: "/paint_task_manage",
          component: () => import("@/components/page/PaintTaskManage"),
          meta: {
            title: "关卡任务管理",
          },
        },
        {
          path: "/config_cate",
          component: () => import("@/components/page/ConfigurationCate"),
          meta: {
            title: "分类配置",
          },
        },
      ]
    },
    {
      path: "/login",
      component: () =>
        import("@/components/page/Login"),
    },
    {
      path: "*",
      redirect: "/404",
    },
  ],
});
